<!-- <div class="container my-4"> -->
<fa-global-navbar [data]="navbarData"  (tabChanged)="changeActiveId($event)" (logoutClicked)="logout($event)">
</fa-global-navbar>
<!-- </div> -->

<hr class="mt-n3" />

<div class="container overflow-custom position-relative">
    <div class="tab-content">
        <div *ngIf="activeId === 'overview'" class="tab-pane fade show active" id="overview">
            <div class="d-flex justify-content-between align-items-center">
                <div class="ms-1">
                    <h4>👋 Hello, {{ userDetails?.firstName }} {{ userDetails?.lastName }}</h4>
                </div>

                <div *ngIf="visaInterviewDate" class="border-custom px-3 y-1">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="me-2 text-primary">
                            <p class="mb-0">
                                <span><i class="bi bi-calendar4-week"></i></span> My Visa
                                Interview Date
                            </p>
                        </div>

                        <div class="text-primary-dark">
                            <h5 class="mb-0">{{ visaInterviewDate | date }}</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row align-items-start mb-1">
                <div class="col-4 position-relative p-3">
                    <img class="img img-fluid"
                        src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1731148102377Frame%201000002298.png"
                        alt="overall_performance" />
                    <div class="position-absolute text-light overall_performance mt-3 p-3">
                        <p class="mb-1">Your Overall Performance</p>
                        <h1 class="mb-7 satoshi-black">{{ overallperformance ?? 0 }}%</h1>
                    </div>
                </div>

                <ng-template #loading>
                    <p>Loading data, please wait...</p>
                </ng-template>

                <div class="col-5 position-relative mt-5">
                    <div *ngIf="graphData.length > 0; else loading" class="border-custom-graph rounded-1">
                        <fa-metrics-grpahs [data]="graphData"></fa-metrics-grpahs>
                    </div>
                    <ng-template #loading>
                        <p>Loading data, please wait...</p>
                    </ng-template>
                </div>

                <div class="col-3 profile-details w-25 mt-4">
                    <div class="card p-3">
                        <h5 class="mb-1 satoshi-bold text-primary-dark mt-n2 text-center mb-4">
                            Your Profile
                        </h5>

                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <small class="mb-0"><span class="text-gray fs-6 me-1"><svg
                                            xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            fill="currentColor" class="bi bi-mortarboard" viewBox="0 0 16 16">
                                            <path
                                                d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917zM8 8.46 1.758 5.965 8 3.052l6.242 2.913z" />
                                            <path
                                                d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466zm-.068 1.873.22-.748 3.496 1.311a.5.5 0 0 0 .352 0l3.496-1.311.22.748L8 12.46z" />
                                        </svg></span>Degree</small>
                                <p class="satoshi-bold text-primary-dark text-center">
                                    {{ this.userDetails?.targetDegree }}
                                </p>
                            </div>

                            <div>
                                <small class="mb-0">
                                    <span class="text-gray fs-6"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                                            height="16" fill="currentColor" class="bi bi-passport" viewBox="0 0 16 16">
                                            <path
                                                d="M8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z" />
                                            <path
                                                d="M3.232 1.776A1.5 1.5 0 0 0 2 3.252v10.95c0 .445.191.838.49 1.11.367.422.908.688 1.51.688h8a2 2 0 0 0 2-2V4a2 2 0 0 0-1-1.732v-.47A1.5 1.5 0 0 0 11.232.321l-8 1.454ZM4 3h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1" />
                                        </svg>
                                    </span>
                                    Visa Type</small>
                                <p class="satoshi-bold text-primary-dark text-center">
                                    {{ visaInterviewStatus }}
                                </p>
                            </div>
                        </div>

                        <div>
                            <small class="mb-0"><span class="text-gray fs-6 me-1"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-buildings" viewBox="0 0 16 16">
                                        <path
                                            d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022M6 8.694 1 10.36V15h5zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5z" />
                                        <path
                                            d="M2 11h1v1H2zm2 0h1v1H4zm-2 2h1v1H2zm2 0h1v1H4zm4-4h1v1H8zm2 0h1v1h-1zm-2 2h1v1H8zm2 0h1v1h-1zm2-2h1v1h-1zm0 2h1v1h-1zM8 7h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zM8 5h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zm0-2h1v1h-1z" />
                                    </svg></span>University</small>
                            <p class="satoshi-bold text-primary-dark">
                                {{ this.userDetails?.academicDetails?.university }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <h5 class="mb-3 ms-3">Visa Mock Interviews</h5>

            <div class="d-flex justify-content-center  p-3 align-items-center mt-n1 ms-3 bg-primary-custom mb-3" *ngIf=" (licenseDetails?.isPaymentRelatedPartner ||
                licenseDetails?.isPaymentRelatedPartner===null||!licenseDetails?.isPaymentRelatedPartner)
                && (licenseDetails?.paymentStatus !=='pending' ||!licenseDetails?.paymentStatus||
                licenseDetails?.paymentStatus===null) && (licenseDetails?.freeAttempts==='0'
                ||!licenseDetails?.freeAttempts|| licenseDetails?.freeAttempts===null)">
                <div class="width-row-size px-3 py-2">
                    <div class="row row-cols-4 horizontal-scroll">
                        <div *ngFor="let interview of mockInterviews; let i = index" class="card me-2">
                            <div class="card-body p-2">
                                <div class="d-flex justify-content-between align-items-start mb-0">
                                    <p class="fw-bold fs-5 mb-2 text-primary-dark">
                                        {{ interview.title }}
                                    </p>
                                    <small class="text-nowrap">
                                        <span><i class="bi bi-arrow-repeat text-primary"></i></span>
                                        {{ interview?.remainingAttempts }} /
                                        {{ interview?.attempts }}
                                    </small>
                                </div>

                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <small><span><i class="bi bi-clock text-primary"></i></span>
                                        {{ interview.difficulty }}</small>
                                    <small><span><i class="bi bi-files text-primary"></i></span>
                                        {{ interview.questions }}</small>
                                    <small><span><i class="bi bi-arrow-repeat text-primary"></i></span>
                                        {{ interview.attempts }} Attempts</small>
                                </div>

                                <button (click)="openDisclaimer(interview)" [disabled]="
                    loadingBtn ||
                    +interview.remainingAttempts >= +interview.attempts ||
                    (i > 0 && +mockInterviews[i - 1].remainingAttempts < 1)
                  " [ngClass]="{
                    'disabled-button':
                      loadingBtn ||
                      +interview.remainingAttempts >= +interview.attempts,
                    'next-test-button':
                      i > 0 && +mockInterviews[i - 1].remainingAttempts < 1
                  }" class="btn btn-outline-primary w-100 interview-btn mb-2">
                                    <span *ngIf="loadingBtn">Loading...</span>
                                    <span *ngIf="!loadingBtn">
                                        <span *ngIf="
                        +interview.remainingAttempts >= +interview.attempts
                      ">Completed</span>
                                        <span *ngIf="+interview.remainingAttempts < +interview.attempts">Take the
                                            interview</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="licenseDetails?.isPaymentRelatedPartner && licenseDetails?.paymentStatus === 'pending' && licenseDetails?.freeAttempts === '0'"
                class="interview-section position-relative">
                <div
                    class="overlay position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center opacity text-center">
                    <div class="p-4 rounded">
                        <i class="bi bi-lock fs-1 mb-3"></i>
                        <h2 class="fw-bold text-dark mb-2">Payment Required</h2>
                        <p class="text-dark mb-4 px-3">
                            Please complete your payment to unlock the mock interview feature.
                            Once payment is confirmed, you will be able to access your mock interview and receive
                            feedback on your performance.
                        </p>
                        <button class="btn btn-primary btn-lg px-5 py-2 text-white opacity"
                            (click)="onPayNow(licenseDetails?.paymentAmountForMockVisa)">
                            Pay Now
                        </button>
                    </div>
                </div>

                <!-- Row of Cards (Max 5) -->
                <div class="width-row-size-disabled px-2 py-2 grayscle">
                    <div class="row row-cols-4 ">
                        <div *ngFor="let interview of mockInterviews | slice:0:3; let i = index" class="card me-1">
                            <div class="card-body p-2">
                                <div class="d-flex justify-content-between align-items-start mb-0">
                                    <p class="fw-bold fs-5 mb-2 text-primary-dark">
                                        {{ interview.title }}
                                    </p>
                                    <small class="text-nowrap">
                                        <span><i class="bi bi-arrow-repeat text-primary"></i></span>
                                        {{ interview?.remainingAttempts }} /
                                        {{ interview?.attempts }}
                                    </small>
                                </div>

                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <small><span><i class="bi bi-clock text-primary"></i></span>
                                        {{ interview.difficulty }}</small>
                                    <small><span><i class="bi bi-files text-primary"></i></span>
                                        {{ interview.questions }}</small>
                                    <small><span><i class="bi bi-arrow-repeat text-primary"></i></span>
                                        {{ interview.attempts }} Attempts</small>
                                </div>

                                <button (click)="openDisclaimer(interview)" [disabled]="
                    loadingBtn ||
                    +interview.remainingAttempts >= +interview.attempts ||
                    (i > 0 && +mockInterviews[i - 1].remainingAttempts < 1)
                  " [ngClass]="{
                    'disabled-button':
                      loadingBtn ||
                      +interview.remainingAttempts >= +interview.attempts,
                    'next-test-button':
                      i > 0 && +mockInterviews[i - 1].remainingAttempts < 1
                  }" class="btn btn-outline-primary w-100 interview-btn mb-2">
                                    <span *ngIf="loadingBtn">Loading...</span>
                                    <span *ngIf="!loadingBtn">
                                        <span *ngIf="
                        +interview.remainingAttempts >= +interview.attempts
                      ">Completed</span>
                                        <span *ngIf="+interview.remainingAttempts < +interview.attempts">Take the
                                            interview</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div *ngIf="activeId === 'my-tests'" class="tab-pane fade" class="mt-1" id="my-tests">
            <div class="d-flex justify-content-end align-items-center alert-message">
                <div *ngIf="showAlert"
                    class="d-flex justify-content-end align-items-center position-relative border border-1 bg-success rounded-1 me-1">
                    <ngb-alert class="mt-1 mb-1 text-light" type="">
                        Watch this video to learn how to interpret the interview feedback
                        results effectively.
                    </ngb-alert>
                    <button type="button" class="btn-close px-2 text-white close-btn mt-n1" aria-label="Close"
                        (click)="closeAlert()">
                        <i class="bi bi-x-circle text-light"></i>
                    </button>
                </div>

                <div>
                    <button class="btn btn-primary rounded-1 text-light" (click)="openInsightInterviewPopup()">
                        Insights Video
                    </button>
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mx-2">
                <h3 class="ms-2">📝 My Mock Interviews</h3>
                <p class="">
                    Total Mock Interviews Taken:
                    <span class="fw-bold text-primary-dark">{{ scenarios?.length }}</span>
                </p>
            </div>

            <div class="container mt-2 mb-4">
                <div class="list-group">
                    <div *ngFor="let scenario of scenarios"
                        class="list-group-item d-flex justify-content-between align-items-center py-3"
                        [ngClass]="{ 'latest-test': scenario?.isLatest }">
                        <div class="d-flex justify-content-around align-items-center">
                            <small class="text-muted me-6">{{
                                scenario?.createdAt | date : "yyyy-MM-dd HH:mm:ss"
                                }}</small>
                            <h5 class="mb-1 text-primary-dark">
                                {{ scenario?.Round }}
                                <span class="text-muted fs-6">• Attempt {{ scenario?.attemptNumber }}</span>
                                <span *ngIf="scenario?.isLatest"
                                    class="badge bg-warning ms-2 p-2 rounded-1">Latest</span>
                            </h5>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="me-2">
                                <small>Overall Score</small>
                            </div>

                            <div class="progress me-2" style="width: 100px">
                                <div class="progress-bar" role="progressbar" [style.width.%]="scenario?.score"
                                    aria-valuenow="{{ scenario?.score }}" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>

                            <strong class="me-2 text-primary">{{ scenario?.score ? scenario?.score : "00" }}%</strong>
                            <button *ngIf="scenario?.status !== 'fail'" (click)="viewInsights(scenario)"
                                class="btn btn-success-custom rounded-1 text-light">
                                View Insights
                            </button>

                            <button *ngIf="scenario?.status === 'fail'"
                                class="text-decoration-none bg-transparent border-0 text-danger cursor-normal">
                                Not Available
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <ng-template #insightInterviewModal>
                <div class="card p-2">
                    <div class="modal-header">
                        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
                    </div>

                    <div class="d-flex justify-content-center align-items-center">
                        <div class="popover bs-popover-top show position-absolute top-left-custom translate-middle">
                            <div class="popover-arrow"></div>
                            <h3 class="popover-header">
                                🎯 Must Watch Before Your Interview
                            </h3>
                        </div>

                        <div>
                            <div *ngIf="avansePuidEnable">
                                <video width="500" height="250" controls controlsList="nodownload">
                                    <source src="/assets/videos/avanse_interview_insight_overview.mp4"
                                        type="video/mp4" />
                                </video>
                            </div>

                            <div *ngIf="!avansePuidEnable">
                                <video width="500" height="250" controls controlsList="nodownload">
                                    <source src="/assets/videos/interview_insight_overview.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>

        <div>
            <div *ngIf="isPoweredByTextVisible()" class="poweredby-position">
                <p class="text-smaller mt-n3">Powered by <span><img class="poweredby"
                            src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1728451685720VisaMonk.ai%203.png"
                            alt="visamonk.ai" /></span>
                </p>
            </div>
        </div>
    </div>
</div>

<!-- Coventry Interview Fullscreen Overlay -->
<div *ngIf="showCoventryIframe" class="coventry-fullscreen-overlay">
  <iframe
    id="coventry-iframe"
    [src]="coventryIframeUrl"
    allow="camera; microphone; fullscreen *; display-capture *; autoplay"
    allowfullscreen
    (load)="onCoventryIframeLoad($any($event.target))"
  ></iframe>
</div>

<ng-template #disclaimerPopup let-c="close" let-d="dismiss">
    <div class="card">
        <div class="modal-header">
            <button *ngIf="
          visaInformation?.id &&
            visaInformation?.visaInterviewPlan?.plan !== 'Wishlist';
          else redirect
        " type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
            <ng-template #redirect>
                <button type="button" class="btn-close" aria-label="Close" (click)="redirectUrl()"></button>
            </ng-template>
        </div>
        <div class="row align-items-center py-6 px-3">
            <div class="col-6 mt-n3 position-relative">
                <div class="popover bs-popover-top show position-absolute top-custom translate-middle">
                    <div class="popover-arrow"></div>
                    <h3 class="popover-header">🎯 Must Watch Before Your Interview</h3>
                </div>

                <div>
                    <div *ngIf="avansePuidEnable">
                        <video width="500" height="250" controls controlsList="nodownload">
                            <source src="/assets/videos/avanse_interview_process_overview.mp4" type="video/mp4" />
                        </video>
                    </div>

                    <div *ngIf="!avansePuidEnable">
                        <video width="500" height="250" controls controlsList="nodownload">
                            <source src="/assets/videos/interview_process_overview.mp4" type="video/mp4" />
                        </video>
                    </div>
                </div>

                <div>
                    <h6 class="ms-3">
                        Watch this video to learn how to go through a mock interview
                        process.
                    </h6>
                </div>
            </div>

            <div class="col-6">
                <div *ngIf="step === 'firstStep'" class="p-3 border-disclaimer text-start">
                    <p class="fw-bold">Disclaimer</p>
                    <li class="mb-2">
                        This tool is intended for practice only and does not guarantee the
                        success of your visa application. Visa interview questions and
                        outcomes may vary in actual interviews conducted by immigration
                        authorities.
                    </li>
                    <li class="mb-2">
                        The license provided is for your personal use only. Any unauthorized
                        sharing or misuse of the license will result in its immediate
                        termination.
                    </li>
                    <li class="mb-2">
                        This platform is not liable for any visa rejections or interview
                        outcomes. The tool is solely intended to assist in your preparation
                        and should not be considered a guarantee of success.
                    </li>

                    <div class="d-flex justify-content-start align-items-center">
                        <input class="me-2" type="checkbox" id="agreeCheckbox" [(ngModel)]="isChecked" />
                        <label for="agreeCheckbox">I have read and agree to the disclaimer</label>
                    </div>

                    <div class="text-center mt-4 d-flex justify-content-end align-items-center">
                        <button class="btn btn-outline-primary-custom px-4 py-2 text-primary me-2" (click)="goBack()">
                            Back
                        </button>
                        <button (click)="goToInstruction()" class="px-4 py-2 text-light"
                            [ngClass]="!isChecked ? 'disable-btn' : 'btn-next'" [disabled]="!isChecked">
                            Next
                        </button>
                    </div>
                </div>

                <div *ngIf="step === 'secondStep'" class="p-3 border-disclaimer text-start">
                    <p class="fw-bold">
                        Instructions- This is a
                        <span class="fw-bold">Mock VISA Interview Assessment.</span>
                    </p>
                    <p class="mb-1"></p>
                    <p>
                        👉 Each mock interview can be attempted only
                        <span class="fw-bold">twice.</span>
                    </p>

                    <h6>✅ DO's</h6>
                    <li class="mb-1"> Ensure a <span class="fw-bold">stable internet, working webcam, audio, and a
                            quiet, distraction-free environment</span> before starting.</li>
                    <li class="mb-1">Not ready? Click <span class="fw-bold">Close button</span> to <span
                            class="fw-bold">exit safely.</span>. </li>
                    <li class="mb-1">For any issues, click on the <span class="fw-bold">"Need Help?"</span> button in
                        the main Dashboard and fill out the form. Or contact us at <span> <a
                                [href]=visamonkPermissions[puid]?.instructionSupportEmailText
                                class="text-primary">{{visamonkPermissions[puid]?.instructionSupportEmailText.replace('mailto:','')}}</a></span>
                    </li>
                    <li class="mb-1"><span class="fw-bold">Review your mock interview feedback immediately</span> after
                        each attempt.</li>
                    <li class="mb-1">If the <span class="fw-bold">mock interview score doesn't appear</span>, try <span
                            class="fw-bold">refreshing the browser</span></li>
                    <li class="mb-2"><span class="fw-bold">Pro Tip:</span> Complete the <span class="fw-bold">first
                            attempts of all mock interview scenarios</span> before <span class="fw-bold">reattempting
                        </span>any.</li>


                    <h6>❌ DON'Ts</h6>
                    <li class="mb-1">Once the mock interview has started, avoid <span class="fw-bold"> 3+ minutes of
                            inactivity </span>– it will <span class="fw-bold">auto-end</span> the mock interview and
                        <span class="fw-bold">count as an attempt.</span>
                    </li>
                    <li class="mb-1">Once the mock interview has started, <span class="fw-bold">do not switch tabs,
                            close the browser, or multitask</span> – this is a <span class="fw-bold">Proctored
                            Environment.</span></li>
                    <li class="mb-1"><span class="fw-bold">Pro Tip: Avoid reattempting the same mock interview scenario
                            immediately</span> – give it time for <span class="fw-bold">better interview realism.</span>
                    </li>

                    <div class="text-center mt-4 d-flex justify-content-end align-items-center">
                        <button class="btn btn-outline-primary-custom px-4 py-2 text-primary me-2" (click)="goBack()">
                            Back
                        </button>
                        <button (click)="startCoventryInterview(selectedInterview)" class="px-4 py-2 text-light"
                            [ngClass]="!isChecked ? 'disable-btn' : 'btn-next'" [disabled]="!isChecked">
                            Start Interview
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #offerCodePopup let-c="close" let-d="dismiss">
    <div class="card">
        <div class="modal-header">
            <button type="button" class="btn-close" aria-label="Close" (click)="closeOfferCodePopup()"></button>
        </div>
        <div class="modal-body p-4">
            <!-- Pricing Display -->
            <div class="pricing-display p-4 mb-4">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fw-bold text-muted">Original Price:</span>
                    <span class="fw-bold text-primary fs-4" [ngClass]="{'original-price': showDiscountedPrice}">
                        {{visaService?.partnerDetails?.company?.paymentCurrency}} {{currentOriginalPrice}}
                    </span>
                </div>

                <div *ngIf="showDiscountedPrice" class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fw-bold text-success">Discounted Price:</span>
                    <span class="discounted-price">
                        {{visaService?.partnerDetails?.company?.paymentCurrency}} {{currentDiscountedPrice}}
                    </span>
                </div>

                <div *ngIf="showDiscountedPrice" class="text-center p-2 rounded"
                    style="background: rgba(40, 167, 69, 0.1);">
                    <small class="savings-text">
                        🎉 You save {{currentDiscountPercent}}%
                        ({{visaService?.partnerDetails?.company?.paymentCurrency}} {{(currentOriginalPrice -
                        currentDiscountedPrice).toFixed(2)}})
                    </small>
                </div>

                <div *ngIf="!showDiscountedPrice" class="text-center">
                    <small class="text-muted">Enter a valid offer code to see your discount</small>
                </div>
            </div>

            <aerp-base-schema-form *ngIf="offerCodeFields && offerCodeModel" [model]="offerCodeModel"
                [dataProcessor]="offerCodeDataProcessor.bind(this)" [dataModel]="'offer-code'"
                (onSubmit)="onOfferCodeSubmit($event)" [layout]="offerCodeFields">
            </aerp-base-schema-form>
        </div>
    </div>
</ng-template>
<div class="preloader-container text-center" *ngIf="loadingCoventryIframe">
    <mat-spinner class="mx-auto mt-3"></mat-spinner>
</div>